import { render } from "./InventoryQueueTab.vue?vue&type=template&id=8e274638&scoped=true"
import script from "./InventoryQueueTab.vue?vue&type=script&lang=js"
export * from "./InventoryQueueTab.vue?vue&type=script&lang=js"

import "./InventoryQueueTab.vue?vue&type=style&index=0&id=8e274638&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8e274638"]])

export default __exports__